import { connect } from 'react-redux'

import Header from '../components/Header'
import * as actions from '../actions/'
import { RootState } from '../types'
import { Login } from '@bdswiss/mt4-connector'
import { Dispatch } from 'redux'

export function mapStateToProps(rootState: RootState) {
  return {
    mode: rootState.appConfig.mode,
    demo: rootState.appConfig.demo,
    theme: rootState.appState.appTheme,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<actions.TradingAction>) {
  return {
    onDeposit: () => dispatch(actions.setDeposit()),
    doLogin: (login: Login) => {
      dispatch(actions.doLogin(login))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)
